<template>
  <div>
    <heading>{{this.$t('jobs.referral')}}</heading>
    <p class="text">
      {{this.$t('jobs.referralInfo')}}
    </p>
    <autocomplete v-model="selections" />
    <div class="selections">
      <job-row-card class="job-card"
        v-for="(job, index) in selections" :key="index" :job="job" v-on:click="click" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Heading from '@/components/general/heading'
import Autocomplete from '@/components/jobseekers/jobs-autocomplete-field'
import JobRowCard from '@/components/jobs/job-row-card'

export default {
  components: { Heading, Autocomplete, JobRowCard },
  computed: {
    ...mapState('jobseekerReferral', {
      selections: 'selected'
    })
  },
  methods: {
    click (e) {
      this.$store.dispatch('jobseekerReferral/refferaldelete', { jobid: e.jobid, approve: true })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

p {
  line-height: 1.5;
  margin-bottom: 1.5rem;
}

.card.job-card {
  cursor: pointer;
}

.card.job-card:hover {
  background-color: $hover-background;
}

.card.job-card:not(:first-child) {
  border-top: 0;
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
}

.card.job-card:not(:last-child) {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}

.selections {
  margin-top: 1.5rem;
}

</style>



// WEBPACK FOOTER //
// src/components/jobseekers/job-referral-form.vue